var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45235 4.19998C8.85622 4.19793 8.26554 4.31345 7.71411 4.53993C7.16268 4.7664 6.66131 5.09939 6.2387 5.51983C5.81609 5.94027 5.48053 6.43992 5.25122 6.99018C5.02192 7.54045 4.90336 8.13052 4.90234 8.72665V13.3C4.90234 13.4856 4.97609 13.6637 5.10737 13.795C5.23865 13.9262 5.41669 14 5.60234 14H7.23568C7.42133 14 7.59938 13.9262 7.73065 13.795C7.86193 13.6637 7.93568 13.4856 7.93568 13.3V8.72665C7.93553 8.51463 7.98006 8.30496 8.06637 8.1113C8.15269 7.91764 8.27884 7.74435 8.43662 7.60272C8.5944 7.46108 8.78025 7.35429 8.98207 7.2893C9.18388 7.22431 9.39713 7.20259 9.60791 7.22554C9.98591 7.27315 10.3333 7.45783 10.5842 7.74456C10.8351 8.03129 10.972 8.40012 10.969 8.7811V13.3C10.969 13.4856 11.0428 13.6637 11.174 13.795C11.3053 13.9262 11.4834 14 11.669 14H13.3024C13.488 14 13.6661 13.9262 13.7973 13.795C13.9286 13.6637 14.0024 13.4856 14.0024 13.3V8.72665C14.0013 8.13052 13.8828 7.54045 13.6535 6.99018C13.4242 6.43992 13.0886 5.94027 12.666 5.51983C12.2434 5.09939 11.742 4.7664 11.1906 4.53993C10.6392 4.31345 10.0485 4.19793 9.45235 4.19998Z",
    fill: "#8A7C8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 4.90002H0.700001C0.313401 4.90002 0 5.21343 0 5.60003V13.3C0 13.6866 0.313401 14 0.700001 14H2.8C3.1866 14 3.5 13.6866 3.5 13.3V5.60003C3.5 5.21343 3.1866 4.90002 2.8 4.90002Z",
    fill: "#8A7C8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.5C2.7165 3.5 3.5 2.7165 3.5 1.75C3.5 0.783503 2.7165 0 1.75 0C0.783503 0 0 0.783503 0 1.75C0 2.7165 0.783503 3.5 1.75 3.5Z",
    fill: "#8A7C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a8ed8f85d61f50cd4025184e6028680d.svg";
export { ForwardRef as ReactComponent };